// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dZGF","colBig":"styles_colBig__1fRmG","colSmall":"styles_colSmall__3Cbg0"};